<template>
  <div class="full" ref="mounter">
    <div class="fuller-center" v-if="rAPI && openEmoji">
      <div v-if="mode === 'emoji'">
        <div class=" text-2xl text-bold">
          Please Pick 2 Emojis
          {{ words[0] }}
          {{ words[1] }}
        </div>
        <div @click="mode = 'words'">
          or <span class="underline">click here</span> to type your chinese name.
        </div>
        <Picker @select="onSelect" />

      </div>
      <div v-if="mode === 'words'">
        <div>
          <div class="text-2xl text-bold">
            Type in 2 Chinese words
          </div>
          <div @click="mode = 'emoji'">
            or <span class="underline">click here</span> to Choose emoji
          </div>

          <input type="text" class="block text-gray-900 text-3xl p-5 rounded-lg border border-gray-500" v-model="wordStr" />
          <button class="block border border-green-200 bg-green-600 text-white px-5 py-3 my-5 rounded-lg" @click="next">Next</button>
        </div>
      </div>
    </div>
    <div class="top-left-btn" @click="openEmoji = true" v-if="rAPI && !openEmoji">
      <span v-if="mode === 'words'">Change name</span>
      <span v-if="mode === 'emoji'">Change emoji</span>
    </div>
    <a class="aroundbtn" href="/lab">
      Home
      <!-- <img class="homebtn w-16 h-16 lg:w-32 lg:h-32" src="../assets/home/jelly-button-blue.svg" alt="Home"> -->
    </a>
  </div>
</template>

<script>
import { Picker } from 'emoji-mart-vue'
import * as EmojiMatrix from '../GLs/EmojiMatrix'
export default {
  components: {
    Picker
  },
  data () {
    return {
      wordStr: '黃樂',
      mode: 'emoji',
      openEmoji: true,
      words: [],
      rAPI: false
    }
  },
  watch: {
    mode () {
      if (!this.rAPI) {
        return
      }
      this.rAPI.setWidthFor(this.mode)
      if (this.mode === 'emoji') {
        this.rAPI.updateWords({ word1: '💎', word2: '⭐️' })
      } else if (this.mode === 'words') {
        this.rAPI.updateWords({ word1: this.wordStr[0] || '☆', word2: this.wordStr[1] || '☆' })
      }
    }
  },
  methods: {
    next () {
      this.rAPI.updateWords({ word1: this.wordStr[0] || '☆', word2: this.wordStr[1] || '☆' })
      this.rAPI.setWidthFor('words')
      this.openEmoji = false
      this.wordStr = '黃樂'
    },
    onSelect (emoji) {
      this.words.push(emoji.native)
      if (this.words.length === 2) {
        this.loading = true
        setTimeout(() => {
          this.rAPI.updateWords({ word1: this.words[0], word2: this.words[1] })
          this.rAPI.setWidthFor('emoji')
          this.words = []
          this.openEmoji = false
        }, 500)
      }
    }
  },
  async mounted () {
    this.rAPI = await EmojiMatrix.install({ mounter: this.$refs['mounter'], vm: this })
    setTimeout(async () => {
      if (this.rAPI.setWidthFor) {
        this.rAPI.setWidthFor('emoji')
      }
    }, 300)
  },
  beforeDestroy () {
    this.rAPI.clean()
  }
}
</script>

<style lang="postcss" scoped>
.homebtn{
  /* background-color: white; */
}

.aroundbtn{
  padding: 15px;
  border-radius: 200px;
  position: absolute;
  display: block;
  top: 20px;
  right: 20px;
  z-index: 100000;
  background-color: rgba(0,0,0,0.6);
  color: white;
  cursor: pointer;
}
.top-left-btn{
  padding: 15px;
  border-radius: 200px;
  position: absolute;
  display: block;
  top: 20px;
  left: 20px;
  z-index: 100000;
  background-color: rgba(0,0,0,0.6);
  color: white;
  cursor: pointer;
}
.fuller-center{
  padding: 20px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0px;
  left: 0px;
  z-index: 100000;
  background-color: rgba(255,255,255,0.8);
  width: 100%;
  height: 100%;
}
</style>
